import { ItemList } from 'orm'

class ParcelList extends ItemList {
    getEntityKey() {
        return "contact/parcel"
    }
}

export const contactParcelList = new ParcelList("contact_parcel__default")
